import { GEOCODE, LOCATION_API_PATHS, type DeliveryLocation, type LocationSuggestion } from '../constants/location'
import { deliveryLocationFromSuggestion } from '../helpers/location'
import { apiRequest } from './client'

export async function searchLocations(query: string): Promise<LocationSuggestion[]> {
  const normalized = query.trim()
  if (normalized.length < 2) return []

  return apiRequest<LocationSuggestion[]>(LOCATION_API_PATHS.search, {
    query: {
      q: normalized,
      limit: GEOCODE.searchLimit,
    },
  })
}

export async function reverseGeocode(
  lat: number,
  lng: number,
): Promise<DeliveryLocation | null> {
  const suggestion = await apiRequest<LocationSuggestion | null>(
    LOCATION_API_PATHS.reverse,
    {
      query: { lat, lng },
    },
  )

  return suggestion ? deliveryLocationFromSuggestion(suggestion) : null
}
